import React from "react";
import {
  FormikControlAtomProps,
  FormikControlAtom as FormikControlAtomComponents,
} from "c4u-web-components";
import { useTranslation } from "react-i18next";

interface IProps extends Omit<FormikControlAtomProps, "translate"> {}

export const FormikControlTradeinAtom: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { children, ...FormikProps } = props;

  return (
    <FormikControlAtomComponents translate={t} {...FormikProps}>
      {children}
    </FormikControlAtomComponents>
  );
};
